import React from 'react';
import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import { useQAssureAuth } from '../services/qassureAuth';

const QAssureAIEmbed = () => {
  const { token, qassureUrl, error, loading } = useQAssureAuth();

  if (loading) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" height="calc(100vh - 64px)">
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>Connecting to QAssure AI…</Typography>
      </Box>
    );
  }

  if (error || !token || !qassureUrl) {
    return (
      <Box p={3}>
        <Alert severity="error">
          Unable to authenticate with QAssure AI.
          {error?.response?.data?.detail
            ? ` Server said: ${error.response.data.detail}`
            : ' Check that QASSURE_AUTH_SECRET is configured on both services.'}
        </Alert>
      </Box>
    );
  }

  const src = `${qassureUrl}${qassureUrl.includes('?') ? '&' : '?'}token=${encodeURIComponent(token)}`;

  return (
    <Box sx={{ height: 'calc(100vh - 64px)', width: '100%' }}>
      <iframe
        src={src}
        title="QAssure AI"
        style={{ width: '100%', height: '100%', border: 0 }}
        allow="clipboard-read; clipboard-write"
      />
    </Box>
  );
};

export default QAssureAIEmbed;
